import React from 'react'

import { useModal } from './useModal'

export const useConfirmationModal = onConfirm => {
  const { handleClose, handleOpen, isOpen } = useModal()

  const handleConfirmationClose = React.useCallback(handleClose, [handleClose])

  const handleConfirmationConfirm = React.useCallback(() => {
    handleClose()
    onConfirm()
  }, [handleClose, onConfirm])

  const handleConfirmationOpen = React.useCallback(handleOpen, [handleOpen])

  return {
    handleConfirmationClose,
    handleConfirmationConfirm,
    handleConfirmationOpen,
    isConfirmationOpen: isOpen,
  }
}
